<template>
	<div class="form-text">
		<h3>Новая система записи к врачу</h3>
	</div>
	<div class="form-text">
		Теперь не надо ловить свободные места. Оставьте заявку, и мы запишемся в удобное для вас время.
	</div>
	<Grid :column-num="3" :gutter="8">
		<GridItem icon="clock-o" text="Быстро" />
		<GridItem icon="good-job-o" text="Удобно" />
		<GridItem icon="fire-o" text="Охуенно" />
	</Grid>
	<div class="pd">
		<Button round block type="primary" :to="{name: 'new-appointment'}">Создать заявку</Button>
	</div>
</template>

<script>
import { Grid, GridItem, Button } from 'vant';

export default {
	components: {
		Grid, GridItem, Button,
	},
}
</script>
